// Which tabs the Settings sheet shows, so every signed-in owner can open it. Pure: no screen code, no database calls.
//
//   Labor        always (it lists the owner's own cost categories, from QuickBooks or from spreadsheet uploads and cash costs)
//   Job vendors  QuickBooks is or was connected AND there is QuickBooks data
//   Sorting      same rule as Job vendors
//   Connection   QuickBooks is connected, or it was disconnected but its data is still in Canopy
//                (then the tab offers only "Remove QuickBooks data")
//
// "Was connected" is shown by the data itself: only a QuickBooks sync creates jobs with a QuickBooks id.

export const SETTINGS_TAB_LABELS = { vendors: 'Job vendors', labor: 'Labor', sorting: 'Sorting', connection: 'Connection' };

// Jobs the sync made from QuickBooks customers (same test the server uses to remove them).
export function hasQuickBooksJobs(jobRows) {
  return (jobRows || []).some(j => j && j.qb_job_id !== null && j.qb_job_id !== undefined && j.qb_job_id !== '' && j.source !== 'manual');
}

// Reads at most a few rows of this business's own data: QuickBooks jobs, and expenses to sort (only a sync
// creates those). Returns true or false, or null if either read failed.
export async function loadHasQuickBooksData(client, userId) {
  try {
    const jobs = await client.from('jobs').select('id, qb_job_id, source')
      .eq('contractor_id', userId).not('qb_job_id', 'is', null).limit(25);
    if (jobs.error) return null;
    if (hasQuickBooksJobs(jobs.data)) return true;
    const inbox = await client.from('inbox_tags').select('id').eq('contractor_id', userId).limit(1);
    if (inbox.error) return null;
    return (inbox.data || []).length > 0;
  } catch (e) { // eslint-disable-line no-unused-vars
    return null;
  }
}

// [key, label] pairs in display order. `hasQbData` null means "could not tell": QuickBooks tabs show only
// while connected, so a connected owner never loses them.
export function settingsTabs({ qbConnected, hasQbData }) {
  const data = hasQbData === true || (hasQbData === null && !!qbConnected);
  const keys = [];
  if (data) keys.push('vendors');
  keys.push('labor');
  if (data) keys.push('sorting');
  if (qbConnected || hasQbData === true) keys.push('connection');
  return keys.map(k => [k, SETTINGS_TAB_LABELS[k]]);
}

// Settings is for every signed-in owner. Not in the demo, whose saves are all refused.
export function showSettingsEntry({ demo, signedIn }) {
  return !demo && !!signedIn;
}
